import React from 'react';
import { Container } from 'react-bootstrap';
import './PrivacyPage.css';

const PrivacyPage = () => {
    return (
        <Container className="privacy-page mt-4 mb-5">
            <h1 className="mb-4">Политика обработки персональных данных сервиса «EventPlan»</h1>
            
            <p className="text-muted mb-4">
                <strong>Версия от:</strong> 30 апреля 2026 г.<br />
                <strong>Сайт:</strong> event-plan.ru<br />
                <strong>Оператор:</strong> Частное лицо (владелец сервиса EventPlan)
            </p>

            <section className="privacy-section mb-4">
                <h2>1. Какие данные собираются</h2>
                <p>При регистрации на сайте event-plan.ru собираются следующие данные:</p>
                <ul>
                    <li><strong>Электронная почта (email)</strong> — обязательно. Используется для входа в личный кабинет, восстановления доступа и получения сервисных уведомлений (например, подтверждение участия в мероприятии, напоминания).</li>
                    <li><strong>Имя</strong> — опционально. Указывается по желанию пользователя для удобства общения в рамках мероприятий. Может быть изменено в личном кабинете в любой момент.</li>
                </ul>
                <p>Иные персональные данные (телефон, адрес, паспортные данные) <strong>не запрашиваются и не обрабатываются</strong>.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>2. Цели обработки данных</h2>
                <p>Обработка персональных данных осуществляется исключительно для:</p>
                <ul>
                    <li>регистрации и идентификации пользователя на платформе EventPlan;</li>
                    <li>обеспечения работы личного кабинета;</li>
                    <li>отправки технических и сервисных сообщений, связанных с использованием сайта;</li>
                    <li>коммуникации между участниками мероприятий (отображается только имя, если оно указано).</li>
                </ul>
                <p><strong>Рекламные или маркетинговые рассылки не производятся</strong>, так как сервис не имеет монетизации.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>3. Правовое основание обработки</h2>
                <p>Согласно п. 5 ч. 1 ст. 6 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных», обработка персональных данных физическим лицом исключительно для личных и семейных нужд не требует уведомления Роскомнадзора. Дополнительным основанием является ваше добровольное согласие, выраженное путём проставления галочки при регистрации.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>4. Как изменяется имя</h2>
                <ul>
                    <li>Имя не является критичным для идентификации.</li>
                    <li>Пользователь может:
                        <ul>
                            <li>не указывать имя (тогда в интерфейсе сервиса будет отображаться ваш email или стандартное обозначение «Участник»);</li>
                            <li>изменить имя в личном кабинете в любое время без согласования с оператором;</li>
                            <li>указать псевдоним.</li>
                        </ul>
                    </li>
                </ul>
            </section>

            <section className="privacy-section mb-4">
                <h2>5. Передача данных третьим лицам</h2>
                <p>Персональные данные (email и имя) <strong>не передаются третьим лицам</strong>, за исключением случаев, прямо предусмотренных законодательством РФ (например, по запросу суда или правоохранительных органов).</p>
                <p>Данные не продаются, не передаются рекламным сетям и не используются для таргетинга.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>6. Хранение и удаление данных</h2>
                <ul>
                    <li>Email и имя хранятся в базе данных сайта event-plan.ru.</li>
                    <li>Технические меры защиты: пароль, SSL-шифрование, регулярное обновление ПО.</li>
                    <li>Срок хранения — до момента отзыва вами согласия или удаления вашего аккаунта.</li>
                    <li>После удаления аккаунта все персональные данные уничтожаются в течение <strong>14 календарных дней</strong>.</li>
                </ul>
            </section>

            <section className="privacy-section mb-4">
                <h2>7. Ваши права</h2>
                <p>Как субъект персональных данных, вы имеете право:</p>
                <ul>
                    <li>отозвать согласие на обработку;</li>
                    <li>потребовать удалить ваш email и имя;</li>
                    <li>потребовать исправить имя (но это вы можете сделать самостоятельно в личном кабинете).</li>
                </ul>
                <p>Для этого достаточно написать письмо с вашего зарегистрированного email на адрес: <strong>support@event-plan.ru</strong></p>
                <p>Запрос будет рассмотрен в течение <strong>10 рабочих дней</strong>.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>8. Отзыв согласия и удаление аккаунта</h2>
                <p>Вы можете в любой момент отозвать согласие на обработку персональных данных, направив письмо на <strong>support@event-plan.ru</strong> с темой «Отзыв согласия» и указанием вашего email. После этого ваш аккаунт будет удалён, а данные стёрты.</p>
            </section>

            <section className="privacy-section mb-4">
                <h2>9. Контактная информация оператора</h2>
                <p>По всем вопросам, связанным с персональными данными, вы можете обратиться:</p>
                <p><strong>Email:</strong> <a href="mailto:support@event-plan.ru">support@event-plan.ru</a></p>
                <p className="text-muted small">Иные персональные данные оператора (ФИО, адрес) не публикуются в настоящем документе в целях безопасности и в соответствии с тем, что оператор является частным лицом, не осуществляющим предпринимательскую деятельность. Данные могут быть предоставлены только по официальному запросу уполномоченных государственных органов.</p>
            </section>
        </Container>
    );
};

export default PrivacyPage;
